module.exports = __webpack_public_path__ + "static/paramount-aeb413dadfe9a48ef66f1ac0c7a1f6d6.png";